<div class="kt-header-title-logo">
	<img class="kt-header-title-logo-image" src="assets/media/logos/sumax-erp-logo.svg" alt="logo sumax docuemntos operativos" />
	<h5 class="kt-header-title-logo-text">{{ title }}</h5>
	<span class="kt-header-title-logo-separator"></span>
</div>
<h4 class="kt-header-title-text">{{ desc }}</h4>
